import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import DangerouslySetInnerHTML from '../../components/DangerouslySetInnerHTML';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    color: 'white',
    backgroundColor: theme.palette.primary.main,
  }
}));

interface IDataConfirmationProps {
  open: boolean,
  text: string;
  onAccept: () => void;
  onCancel: () => void;
}

const DataConfirmation = ({ open, text, onAccept, onCancel }: IDataConfirmationProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
      <Dialog
        open={open}
      >
        <DialogTitle className={classes.root}>
          <Typography variant='h5'>
            {t('pages.bpm.modalConfirmation.title')}
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <DangerouslySetInnerHTML text={text} />
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            color='primary'
            variant='contained'
            onClick={onAccept}
          >
            {t('pages.bpm.modalConfirmation.btnAccept')}
          </Button>
          <Button
            color='inherit'
            variant='outlined'
            onClick={onCancel}
          >
            {t('pages.bpm.modalConfirmation.btnCancel')}
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default DataConfirmation;